import { changeRangeValueAction } from './changeRangeValueAction';

export const changePriceMinAction = (value: number): ReturnType<typeof changeRangeValueAction> =>
  changeRangeValueAction({ fieldName: 'price', rangeValueKey: 'min', value });
